export { OneTrustButton } from './legacy';
export { OneTrustV2 } from './OneTrust.v2';
export { OneTrustScripts } from './OneTrustScripts';
export { OneTrustHeadScriptV2 } from './one-trust-head-script.v2';
